import Vue from 'vue';
import Router from 'vue-router';

const Styleguide = () => import('@/pages/Styleguide');
const Guidelines = () => import('@/pages/Guidelines');
import PageNotFound from '@/pages/PageNotFound';
import AuthenticationPage from '@/pages/AuthenticationPage';


import Homepage from '@/pages/Homepage';
import Trajectories from '@/pages/Trajectories';
import Evaluations from '@/pages/Evaluations';
import WorkProcesses from '@/pages/WorkProcesses';
import EvaluationStudents from '@/pages/EvaluationStudents';
import Chart from '@/pages/Chart';
import PendingEvaluations from '@/pages/PendingEvaluations';
import Profile from '@/pages/Profile';
import Dashboard from '@/pages/Dashboard';
import InvoiceDetails from '@/pages/InvoiceDetails';
import ApprovalRequestReview from '@/pages/ApprovalRequestReview';

import SurveyTemplate from '@/pages/SurveyTemplate';
const SurveyTemplates = () => import('@/pages/SurveyTemplates');

import SurveyFill from '@/pages/SurveyFill';
import SurveyResults from '@/pages/SurveyResults';
import DocumentTemplate from '@/pages/DocumentTemplate';
import NextRedirect from '@/pages/NextRedirect';
const DocumentTemplates = () => import('@/pages/DocumentTemplates');

import Help from '@/pages/Help';

// Authentication Pages
import LoginForm from '@/components/auth/forms/LoginForm';
import RegisterForm from '@/components/auth/forms/RegisterForm';
import PasswordResetForm from '@/components/auth/forms/PasswordResetForm';
import PasswordForgottenForm from '@/components/auth/forms/PasswordForgottenForm';
import ActivationPage from '@/components/auth/ActivationPage';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [
        {
            path: '/',
            redirect: '/homepage'
        },
        {
            path: '/homepage',
            name: 'homepage',
            component: Homepage,
            meta: { auth: false }
        },
        {
            path: '/pending-evaluations',
            name: 'pending-evaluations',
            component: PendingEvaluations,
            meta: { auth: true }
        },
        {
            path: '/evaluation-students',
            name: 'evaluation-students',
            component: EvaluationStudents,
            meta: { auth: true }
        },
        {
            path: '/evaluation-students/:user_id/:diploma_id/:work_process_id/:evaluation_id',
            name: 'evaluation-student',
            component: Profile,
            meta: { auth: true }
        },
        {
            path: '/trajectories',
            name: 'trajectories',
            component: Trajectories,
            meta: { auth: true }
        },
        {
            path: '/next-evaluation/:evaluation_id',
            name: 'next-evaluation',
            component: NextRedirect,
            meta: { auth: true }
        },
        {
            path: '/chart/:user_id/:diploma_id',
            name: 'chart',
            component: Chart,
            meta: { auth: true }
        },
        {
            path: '/evaluations/:id',
            name: 'evaluations',
            component: Evaluations,
            meta: { auth: true }
        },
        {
            path: '/work-processes/:id',
            name: 'work-processes',
            component: WorkProcesses,
            meta: { auth: true }
        },
        {
            path: '/trajectories/:id',
            name: 'dashboard',
            component: Dashboard,
            meta: { auth: true }
        },
        {
            path: '/trajectory/:trajectoryId/invoice/:invoiceId',
            name: 'edit-invoice',
            component: InvoiceDetails,
            meta: { auth: true }
        },
        {
            path: '/review-client/:token',
            name: 'review-client',
            component: ApprovalRequestReview,
            meta: { auth: false }
        },
        {
            path: '/review-employer/:token',
            name: 'review-employer',
            component: ApprovalRequestReview,
            meta: { auth: false }
        },
        {
            path: '/approve-document/:token',
            name: 'approve-document',
            component: ApprovalRequestReview,
            meta: { auth: false }
        },
        {
            path: '/survey-templates',
            name: 'survey-templates',
            component: SurveyTemplates,
            meta: { auth: true }
        },
        {
            path: '/survey-templates/:id',
            name: 'survey-template',
            component: SurveyTemplate,
            meta: { auth: true }
        },
        {
            path: '/trajectory/:trajectoryId/survey-results/:surveyId',
            name: 'survey-results',
            component: SurveyResults,
            meta: { auth: true }
        },
        {
            path: '/survey-client/:token',
            name: 'survey-client',
            component: SurveyFill,
            meta: { auth: false }
        },
        {
            path: '/survey-employer/:token',
            name: 'survey-employer',
            component: SurveyFill,
            meta: { auth: false }
        },
        {
            path: '/document-templates',
            name: 'document-templates',
            component: DocumentTemplates,
            meta: { auth: true }
        },
        {
            path: '/document-templates/:id',
            name: 'document-template',
            component: DocumentTemplate,
            meta: { auth: true }
        },
        {
            path: '/help',
            name: 'help',
            component: Help,
            meta: {
                auth: true
            }
        },
        {
            path: '/styleguide',
            name: 'styleguide',
            component: Styleguide,
            meta: {
                auth: false,
                debugRoute: true,
            }
        },
        {
            path: '/guidelines',
            name: 'guidelines',
            component: Guidelines,
            meta: {
                auth: false,
                debugRoute: true,
            }
        },
        {
            path: '/auth',
            component: AuthenticationPage,
            children: [
                {
                    path: '/',
                    name: 'sign-in',
                    component: LoginForm
                },
                {
                    path: 'register',
                    name: 'register',
                    component: RegisterForm
                },
                {
                    path: 'reset',
                    component: PasswordForgottenForm,
                    name: 'reset'
                },
                {
                    path: 'reset/:token',
                    component: PasswordResetForm,
                    name: 'reset/token'
                },
                {
                    path: 'activate/:token',
                    component: ActivationPage,
                    name: 'activate'
                }
            ]
        },
        {
            path: '/page_not_found',
            name: 'page_not_found',
            component: PageNotFound
        },
        {
            path: '**',
            redirect: '/page_not_found'
        }
    ],
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.auth) {
        //Check if user is signed in. Route requires sign in.
        if (!Vue.prototype.$auth.isAuthenticated()) {
            next({
                name: 'sign-in',
                query: {
                    redirect: to.path
                }
            });
            return;
        }
    }
    next();
});

/**
* Disable debug routes (stylesheet, etc) on production
*/
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.debugRoute)) {
        if (!Vue.prototype.$config.debug) {
            next({ path: '/' });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js